var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['normalBtn', _vm.isGray ? 'backgroundGray' : '', _vm.isWhiteBg ? 'whiteBg': ''],on:{"click":_vm.onClickBtnFn}},[_c('div',{style:(_vm.fontStyle)},[_vm._v("\n    "+_vm._s(_vm.labBtn)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }